var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarToday(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "material-symbols:calendar-today"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.83333 14.6668C3.46667 14.6668 3.15289 14.5364 2.892 14.2755C2.63111 14.0146 2.50044 13.7006 2.5 13.3335V4.00016C2.5 3.6335 2.63067 3.31972 2.892 3.05883C3.15333 2.79794 3.46711 2.66727 3.83333 2.66683H4.5V1.3335H5.83333V2.66683H11.1667V1.3335H12.5V2.66683H13.1667C13.5333 2.66683 13.8473 2.7975 14.1087 3.05883C14.37 3.32016 14.5004 3.63394 14.5 4.00016V13.3335C14.5 13.7002 14.3696 14.0142 14.1087 14.2755C13.8478 14.5368 13.5338 14.6673 13.1667 14.6668H3.83333ZM3.83333 13.3335H13.1667V6.66683H3.83333V13.3335Z",
    fill: "#344054"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarToday);
export default __webpack_public_path__ + "static/media/calendar-today.d1bfd75a62b8f84baeeefbbe24e0a076.svg";
export { ForwardRef as ReactComponent };